import { fromJS } from 'immutable/dist/immutable';
import { basicSort } from '../../../../util/sortUtils';
import { refColumns, refSort } from '../../../InfoReduxConstant';

export const CLEAR_TSUNAMI_EVENT_INFO = 'CLEAR_TSUNAMI_EVENT_INFO';

export const GET_TSUNAMI_EVENT_INFO_REFERENCES_REQUEST = 'GET_TSUNAMI_EVENT_INFO_REFERENCES_REQUEST';
export const GET_TSUNAMI_EVENT_INFO_REFERENCES_SUCCESS = 'GET_TSUNAMI_EVENT_INFO_REFERENCES_SUCCESS';
export const GET_TSUNAMI_EVENT_INFO_REFERENCES_FAILURE = 'GET_TSUNAMI_EVENT_INFO_REFERENCES_FAILURE';

export const GET_TSUNAMI_EVENT_INFO_REQUEST = 'GET_TSUNAMI_EVENT_INFO_REQUEST';
export const GET_TSUNAMI_EVENT_INFO_SUCCESS = 'GET_TSUNAMI_EVENT_INFO_SUCCESS';
export const GET_TSUNAMI_EVENT_INFO_FAILURE = 'GET_TSUNAMI_EVENT_INFO_FAILURE';

export const TSUNAMI_EVENT_INFO_REFERENCE_SORT = 'TSUNAMI_EVENT_INFO_REFERENCE_SORT';
export const TSUNAMI_EVENT_INFO_TOGGLE_COLUMN = 'TSUNAMI_EVENT_INFO_TOGGLE_COLUMN';

const initialState = fromJS({
  fetchedTsunami: false,
  tsunami: {},
  fetchedReferences: false,
  references: [],

  sort: refSort,
  visibleColumns: refColumns,

});

// default param first is the redux convention https://redux.js.org/tutorials/fundamentals/part-3-state-actions-reducers
// eslint-disable-next-line default-param-last
export const tsunamiEventInfoReducer = (state = initialState, action) => {
  switch (action.type) {
    case CLEAR_TSUNAMI_EVENT_INFO:
      return initialState;

    case TSUNAMI_EVENT_INFO_REFERENCE_SORT:
      return state.merge(fromJS({
        references: basicSort(action.sort, state.get('references')),
        sort: action.sort,
      }));

    case GET_TSUNAMI_EVENT_INFO_REFERENCES_REQUEST:
      return state.set('fetchedReferences', false);
    case GET_TSUNAMI_EVENT_INFO_REFERENCES_SUCCESS:
      return state.merge(fromJS({
        fetchedReferences: true,
        references: basicSort(state.get('sort'), fromJS(action.response.items)),
      }));
    case GET_TSUNAMI_EVENT_INFO_REFERENCES_FAILURE:
      return state.set('fetchedReferences', true);

    case GET_TSUNAMI_EVENT_INFO_REQUEST:
      return state.set('fetchedTsunami', false);
    case GET_TSUNAMI_EVENT_INFO_SUCCESS:
      return state.merge(fromJS({
        fetchedTsunami: true,
        tsunami: action.response,
      }));
    case GET_TSUNAMI_EVENT_INFO_FAILURE:
      return state.set('fetchedTsunami', true);

    case TSUNAMI_EVENT_INFO_TOGGLE_COLUMN:
      return state.merge(fromJS({
        visibleColumns: action.visibleColumns,
      }));

    default:
      return state;
  }
};
